export const TOKEN_KEY = 'token'
export const ENV_KEY = 'env'
export const TOKEN_EXPIRE_TIME = 'token_expire_time'
export const USERNAME_KEY = 'username'

export const getSessionKey = (key) => localStorage.getItem(key)
export const storeSessionKey = (key: string, value: string) => localStorage.setItem(key, value)
export const clearSessionKey = (key: string) => localStorage.removeItem(key)
export const clearLocalStorage = () => {
  localStorage.clear()
}

// Connect Analysis Credentials
export const USER = '92af8adbd7974f06a44308e09a6c3479'
export const PASS = '85E77DaBF991401c86677df85F7e3903'
export const TOKEN = 'YTRiNGNiNGQzNzhkNDFiODgxN2E5YWVjZTBhYjJhY2U6MjUyNzlENTFBMzc3NDllZWI0MmJlOTkwYzVFRWYxM2E='



// WEBPACK FOOTER //
// ./src/util/storage.js